import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import localize from '../util/localizeUtils';

const Container = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  user-drag: none;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-drag: none;
  -webkit-user-select: none;
  -ms-user-select: none;
`;

const RetryButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid #A9A7A7;
  color: #B2B2B2;
  font-size: 16px;
  padding: .5rem .5rem .5rem .5rem;
`;

const ReloadImage = styled.img`
  margin-right: .5rem;
  user-drag: none;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-drag: none;
  -webkit-user-select: none;
  -ms-user-select: none;
`;

class ReloadButton extends Component {
  render() {
    return (
      <Container>
        <RetryButton onClick={this.props.onClick}><ReloadImage src="images/reload.png" />{localize('reloadButton')}</RetryButton>
      </Container>
    );
  }
}

ReloadButton.defaultProps = {
  onClick: () => {}
};

ReloadButton.propTypes = {
  onClick: PropTypes.func
};

export default ReloadButton;



// WEBPACK FOOTER //
// ./app/components/ReloadButton.js